<template>
  <div class="flex ct">
    <div class="flex w-1/2 sm:w-5/12 md:w-1/4 image justify-center"
     @click="$emit('headerclick')">
      <img ref="headerimage" 
           src="https://www.uma.pt/wp-content/themes/uma/images/Logo_UMa_site-01.png" />
    </div>
    <div class="flex w-1/3 sm:w-4/12 md:w-7/12 title"
       @click="$emit('headerclick')">
      <p>{{ $t("pesquisa") }}</p>
    </div>
    <div class="flex items-center sm:w-3/12 md:w-2/12 lang">
      <p :class="{'active': this.$i18n.locale == 'pt'}" @click="switchLanguage('pt')">PT</p>
      <span></span>
      <p :class="{'active': this.$i18n.locale == 'en'}" @click="switchLanguage('en')">EN</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "HeaderNew",
  emits:["headerclick","switchlanguage"],
  methods:{
    switchLanguage(lang){
      this.$i18n.locale = lang;
      this.$emit("switchlanguage");
    }
  }
}
</script>

<style scoped>
@tailwind base;
@tailwind components;
@tailwind utilities;

.ct {
  background-color: #292a2b;
  padding-top: 15px;
  padding-bottom: 15px;
  cursor: pointer;
}

.image{
  align-items: center;
  max-width: 295px;
  padding-left: 0;
  padding-right: 0;
}

.title{
  padding-right: 0.9375rem;
  padding-left: 0.9375rem;
}

.title p{
  margin-bottom: 0;
  color:white;
  font-family: "Montserrat";
  font-size: 30px;
  margin-top: 0px;
  border-bottom: 2px solid transparent;
}

p.active{
  border-bottom: 2px solid #1976d2;
}

img{
  width: 150px;
  height: 46.484px;
  margin-bottom: 5px;
  display: inline;
}

.lang{
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.lang p{
  line-height: 1;
  font-size: 20px;
  color:white;
  font-family: "Montserrat";
  margin-bottom: 0;
}

.lang span {
  margin-left: 7px;
  margin-right: 7px;
  width: 2px;
  height: 40%;
  background: white;
}

.title p {
  font-size: 24px;
  margin-top: 10px;
  margin-left: 35px;
}

@media only screen and (min-width: 1350px) {
  .title p {
    font-size: 25px;
    margin-top: 12px;
    margin-left: 40px;
    margin-bottom: -10px;
  }
}

@media only screen and (max-width: 1300px) {
  .ct{
    padding-top: 10px;
    padding-bottom: 10px;
  }
  .title p{
    font-size: 25px;
  }

  .lang p{
    font-size: 20px;
  }

  .img {
    margin-top: 5px;
  }


}

@media only screen and (max-width: 767px) {
  .title p{
    font-size: 16px;
    padding-top: 7px;
    display: none;
  }

  .lang{
    padding-right: 30px;
  }

  .lang p{
    font-size: 16px;
    padding-top: 3px;
  }
  
  .image{
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  img{
    margin-bottom: 0px;
    width: 120px;
  }

}

@media only screen and (max-width:1200px) and (min-width: 768px) {
  .title p {
    font-size: 22px;
    padding-top: 6px;
    padding-left: 0px;
    margin-left: 32px;
    margin-top: 7px;
  }

  .image img {
    width: 140px;
    height: 43.391px;
    padding-top: 6px;
    margin-bottom: 5px;
  }
}

@media only screen and (max-width:900px) and (min-width: 768px) {

  .image img {
    width: 120px;
    height: 37.188px;
  }

  .title p {
    font-size: 20px;
    padding-top: 8px;
    padding-left: 11%;
  }

  .lang p {
    font-size: 18px;
  }
}

@media only screen and (max-width:767px) and (min-width: 640px) {

    .image {
      flex: 0 0 30%;

    }

    .title {
      flex: 0 0 52.4%;
    }
}

@media only screen and (max-width:1180px) and (min-width: 1024px) {
  .title {
    max-width: 550px;
  }
}

@media only screen and (min-width: 1024px) {
  .image {
    display: block;
    width: 295px;
    min-width: 295px;
    text-align: center;
  }
}

</style>

